import { readRemaining1u8soafhjma7y as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.b5m().q5o(), $completion));
  return SavedHttpCall().z5p(_this__u8e3s4.w5l_1, _this__u8e3s4.b5o(), _this__u8e3s4.b5m(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      static z5p(client, request, response, responseBody) {
        var $this = this.a5o(client);
        $this.x5p_1 = responseBody;
        $this.y5l_1 = new (SavedHttpRequest())($this, request);
        $this.z5l_1 = new (SavedHttpResponse())($this, $this.x5p_1, response);
        checkContentLength(contentLength(response), fromInt($this.x5p_1.length), request.j5o());
        $this.y5p_1 = true;
        return $this;
      }
      d5o() {
        return this.y5p_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.a5q_1 = origin;
        this.b5q_1 = call;
      }
      i5o() {
        return this.b5q_1;
      }
      gw() {
        return this.a5q_1.gw();
      }
      j5o() {
        return this.a5q_1.j5o();
      }
      k5o() {
        return this.a5q_1.k5o();
      }
      c5o() {
        return this.a5q_1.c5o();
      }
      a2p() {
        return this.a5q_1.a2p();
      }
      v55() {
        return this.a5q_1.v55();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.c5q_1 = call;
        this.d5q_1 = body;
        this.e5q_1 = origin.r5o();
        this.f5q_1 = origin.s5o();
        this.g5q_1 = origin.t5o();
        this.h5q_1 = origin.u5o();
        this.i5q_1 = origin.v55();
        this.j5q_1 = origin.gw();
      }
      i5o() {
        return this.c5q_1;
      }
      r5o() {
        return this.e5q_1;
      }
      s5o() {
        return this.f5q_1;
      }
      t5o() {
        return this.g5q_1;
      }
      u5o() {
        return this.h5q_1;
      }
      v55() {
        return this.i5q_1;
      }
      gw() {
        return this.j5q_1;
      }
      q5o() {
        return ByteReadChannel(this.d5q_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save1y71vsgu0wj47,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
